import classNames from "classnames";
import { AppointmentPhase } from "components";
import React from "react";

interface Props {
  appointment: server.dto.PlannerAppointment
  highlighted: boolean
  active: boolean
}

const ItineraryAppointment = (props: Props) => {
  const classes = classNames("content flex", {
    highlighted: props.highlighted
  });

  const innerDivClass = classNames("grow1", {
    active: props.active
  });
  return <div className={classes}>
    <div className={innerDivClass}>
      <div>{props.appointment.sidebarSummary}</div>
      <div className="s1_small">
        {!props.appointment.isAllDay && <>
          <span>{props.appointment.timeStart}</span>
          {props.appointment.timeEnd && <span>&nbsp;- {props.appointment.timeEnd}</span>}
          {props.appointment.startsInNightOfText && <span>&nbsp;{props.appointment.startsInNightOfText}</span>}
        </>}
      </div>
    </div>

    <div>
      <span className={props.appointment.type.icon}></span>
    </div>
    <div>
      <AppointmentPhase value={props.appointment.phase} displayLabel={false} />
    </div>
  </div >;
};

export default ItineraryAppointment;